<ng-container *appTranslate="let t" class="h-full">
  <new-ui-dashboard-card>
    <ng-template #header>
      <new-ui-dashboard-card-header [title]="t('dashboard.milestone.titleCandidate')"> </new-ui-dashboard-card-header>
    </ng-template>

    <new-ui-milestone-candidate-view
      [readonly]="true"
      [candidateId]="candidateId"
      [candidateOrganizationId]="organizationId"
    ></new-ui-milestone-candidate-view>
  </new-ui-dashboard-card>
</ng-container>
